"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const HelpAndFaqsIcon = createIcon({
  displayName: "HelpAndFaqsIcon",
  viewBox: "0 0 45 45",
  path: (
    <>
      <path
        d="M22.39,36c.79,0,1.45-.27,2-.82.54-.54.82-1.21.82-2s-.27-1.45-.82-2c-.54-.54-1.21-.82-2-.82s-1.45.27-2,.82c-.54.54-.82,1.21-.82,2s.27,1.45.82,2c.54.54,1.21.82,2,.82ZM20.36,27.34h4.16c0-1.24.14-2.21.42-2.92.28-.71,1.08-1.69,2.39-2.93.98-.97,1.74-1.9,2.31-2.78.56-.88.84-1.94.84-3.18,0-2.1-.77-3.71-2.31-4.84-1.54-1.12-3.36-1.69-5.46-1.69s-3.87.56-5.2,1.69c-1.33,1.12-2.26,2.48-2.78,4.05l3.71,1.46c.19-.68.61-1.41,1.27-2.19.66-.79,1.66-1.18,3.01-1.18,1.2,0,2.1.33,2.7.98.6.66.9,1.38.9,2.17s-.23,1.45-.68,2.11c-.45.66-1.01,1.27-1.69,1.83-1.65,1.46-2.66,2.57-3.04,3.32s-.56,2.12-.56,4.11ZM22.5,45c-3.11,0-6.04-.59-8.77-1.77-2.74-1.18-5.12-2.78-7.14-4.81-2.03-2.03-3.63-4.41-4.81-7.14-1.18-2.74-1.77-5.66-1.77-8.77s.59-6.04,1.77-8.77c1.18-2.74,2.78-5.12,4.81-7.14,2.02-2.03,4.41-3.63,7.14-4.81,2.74-1.18,5.66-1.77,8.77-1.77s6.04.59,8.77,1.77c2.74,1.18,5.12,2.78,7.14,4.81,2.02,2.02,3.63,4.41,4.81,7.14,1.18,2.74,1.77,5.66,1.77,8.77s-.59,6.04-1.77,8.77c-1.18,2.74-2.78,5.12-4.81,7.14-2.03,2.02-4.41,3.63-7.14,4.81-2.74,1.18-5.66,1.77-8.77,1.77ZM22.5,40.5c5.02,0,9.28-1.74,12.77-5.23s5.23-7.74,5.23-12.77-1.74-9.28-5.23-12.77c-3.49-3.49-7.74-5.23-12.77-5.23s-9.28,1.74-12.77,5.23c-3.49,3.49-5.23,7.74-5.23,12.77s1.74,9.28,5.23,12.77c3.49,3.49,7.74,5.23,12.77,5.23Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default HelpAndFaqsIcon;
